/**
 * @generated SignedSource<<fc9512214e7688b9c3e6251bff5d46cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PlannerDatePicker_account$data = {
  readonly default_full_time_minutes: number;
  readonly id: number;
  readonly " $fragmentSpreads": FragmentRefs<"FullPicker_account" | "MiniPicker_account" | "TimeOffMiniPicker_account">;
  readonly " $fragmentType": "PlannerDatePicker_account";
};
export type PlannerDatePicker_account$key = {
  readonly " $data"?: PlannerDatePicker_account$data;
  readonly " $fragmentSpreads": FragmentRefs<"PlannerDatePicker_account">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PlannerDatePicker_account",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "default_full_time_minutes",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MiniPicker_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TimeOffMiniPicker_account"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FullPicker_account"
    }
  ],
  "type": "accounts",
  "abstractKey": null
};

(node as any).hash = "328e818e68010e0b36aab67764166bbf";

export default node;
